import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'time',
})
export class TimePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: unknown) {
    if (value) {
      const timeArr = (value as string).split(':');

      let [hours] = timeArr;
      const minutes = timeArr[1];

      const hourTranslate = this.translateService.instant('common.time.hour');
      const minutesTranslate = this.translateService.instant('common.time.minutes');

      if (hours === '00') return `${minutes} ${minutesTranslate}`;
      if (hours[0] === '0') hours = hours.substring(1);

      return `${hours} ${hourTranslate} ${minutes} ${minutesTranslate}`;
    }
    return '';
  }
}
